export const REQUEST_EXAMS = 'REQUEST_EXAMS'
export const RECEIVE_EXAMS = 'RECEIVE_EXAMS'
export const REQUEST_EXAM_PSICO = 'REQUEST_EXAM_PSICO'
export const RECEIVE_EXAM_PSICO = 'RECEIVE_EXAM_PSICO'
export const REQUEST_CONFIRM_BIRTH = 'REQUEST_CONFIRM_BIRTH'
export const RECEIVE_CONFIRM_BIRTH = 'RECEIVE_CONFIRM_BIRTH'
